import * as React from 'react';

interface DataPoint {
  value: number;
  label: string;
  color: string;
  tooltipContent: React.JSX.Element;
}

interface ScalePoint {
  value: number;
  label: string;
}

export interface RadarChartProps {
  dataHook?: string;
  data?: DataPoint[];
  scale?: ScalePoint[];
  disabled?: boolean;
  width?: number;
  labelDistance?: number;
  hoverIndex?: null | number;
  onDataPointHover?(): void;
}

export default class RadarChart extends React.PureComponent<RadarChartProps> {}
